import React from "react";
import {visit} from "unist-util-visit";

export function getExerciseTitle(exercise) {
    if (exercise?.title) {
        return (
            <p>
                <b>{
                    underlineBrackets(
                        replaceSpecialCodes(exercise.title),
                        'u'
                    )
                }</b>
            </p>
        )
    } else {
        return null
    }
}

export function getExerciseSubtitle(exercise) {
    if (exercise?.subtitle) {
        return (
            <p>
                <span>
                    {
                        underlineBrackets(
                            replaceSpecialCodes(exercise.subtitle),
                            'u'
                        )
                    }
                </span>
            </p>
        )
    } else {
        return null
    }
}

export function getExerciseSentence(exercise) {
    if (exercise?.sentence) {
        return (
            <p>
                <span>
                    {
                        underlineBrackets(
                            replaceSpecialCodes(exercise.sentence),
                            'u'
                        )
                    }
                </span>
            </p>
        )
    } else {
        return null
    }
}

export function getExerciseHint(exercise) {
    if (exercise?.hint) {
        return (
            <p>
                <i>
                    {
                        underlineBrackets(
                            replaceSpecialCodes(exercise.hint),
                            'u'
                        )
                    }
                </i>
            </p>
        )
    } else {
        return null
    }
}

export function getExerciseText(exercise) {
    if (exercise?.text) {
        return (
            <p>
                <span>
                    {
                        underlineBrackets(
                            replaceSpecialCodes(exercise.text),
                            'u'
                        )
                    }
                </span>
            </p>
        )
    } else {
        return null
    }
}

export function getSentencenr(exercise) {
    if (exercise?.sentencenr) {
        return (
            <p>
                {/*<i>Schauen Sie bitte im Lesetext, Zeile {exercise.sentencenr} nach.</i>*/}
                <i>Klicken Sie auf Lesetext, um den Kontext (um Zeile {exercise.sentencenr}) zu sehen.</i>

            </p>
        )
    } else {
        return null
    }
}

export function getExerciseStem(exercise) {
    return (
        <>
            {!(exercise?.title || exercise?.subtitle || exercise?.sentence || exercise?.hint || exercise?.text || exercise?.sentencenr) ?
                <p>&nbsp;</p> : null}
            {getExerciseTitle(exercise)}
            {getExerciseSubtitle(exercise)}
            {getExerciseSentence(exercise)}
            {getExerciseHint(exercise)}
            {getExerciseText(exercise)}
            {/*{getSentencenr(exercise)}*/}
        </>
    )
}

/////////////////////////////

export function underlineBrackets(s, customTag) {
    const re = /{(.+?)}/g;
    var m;
    var current_pos = 0;
    var t = "";
    var arr = [];
    const CustomTag = `${customTag}`
    do {
        m = re.exec(s);
        if (m) {
            if (t != "") {
                t += "]"
            }
            arr.push({'type': 'text', 'content': s.substring(current_pos, m.index)});
            t += s.substring(current_pos, m.index) + "[";
            arr.push({'type': 'fill', 'content': m[1]});
            t += m[1]
            current_pos = m.index + m[0].toString().length;
        }
    } while (m);
    if (t != "") {
        t += "]"
    }
    t += s.substring(current_pos, s.length);
    arr.push({'type': 'text', 'content': s.substring(current_pos, s.length)});
    return arr.map(
        (k, i) => {
            if (k['type'] === 'text') {
                return k['content']
            } else if (k['type'] === 'fill') {
                return (
                    <CustomTag key={i}>{k['content']}</CustomTag>
                )
            }

        }
    );
}

export function replaceSpecialCodes(s) {
    var result = s;
    try {
        result = s.replaceAll("\\*", "\:");
    } catch (e) {
        console.log(s)
    }
    return result
}

export function replaceSpecialCodesInText(s) {
    var result = s;
    try {
        result = s.replaceAll("\\*", "\\:");
    } catch (e) {
        console.log(s)
    }
    return result
}

export function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    // console.log(array)
    return array
}

export function customDirectives() {
    return transform;

    function transform(tree) {
        visit(tree, "textDirective", ondirective);
    }

    function ondirective(node) {
        // console.log(node);
        const {name, attributes, children} = node;
        const text = children[0]?.value ?? "";

        const data = node.data || (node.data = {});
        data.hName = name;
        data.hProperties = {...attributes, text};

        // if (
        //     node.type === 'textDirective' ||
        //     node.type === 'leafDirective' ||
        //     node.type === 'containerDirective'
        // ) {
        //     if (node.name !== 'note') return
        //
        //     const data = node.data || (node.data = {})
        //     const tagName = node.type === 'textDirective' ? 'span' : 'div'
        //
        //     data.hName = tagName
        //     data.hProperties = h(tagName, node.attributes).properties
        // }
    }
}

export function getLesetextWithMarkedSentencenr(lesetext, sentencenr) {
    if (lesetext) {
        if (sentencenr) {
            var lines = lesetext.split('\n')
            // var sentencenr = 5
            var newLines = lines.reduce(
                (prevText, currentLine, idx) => {
                    var cl = replaceSpecialCodesInText(currentLine);
                    return idx == 0 ? cl : prevText + '\n ' + (idx == (sentencenr - 1) ? ':span[' + cl + ']{style="background-color: yellow"}' : cl);
                }, ''
            );
            return newLines
        }
    }
    if (!lesetext) {
        lesetext = "Lesetext ist undefiniert. Prüfen Sie bitte, ob Sie den Lesetext aus einer Aufgabe aufgerufen haben."
    }
    return lesetext
}